// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1__xJ","cls2":"shared-cls2_A9e shared-cls1__xJ"};